module.exports = __webpack_public_path__ + "modules/platform/img/status1.png";